import { Injectable } from '@angular/core';

/**
 * Per-instance configuration service provided by `SpriSingleDatePickerComponent`
 * and injected optionally by `CustomCalendarHeader`.
 *
 * Because it is listed in the component's `providers` array (not `providedIn`),
 * each date-picker instance gets its own copy, so different pickers on the same
 * page can have independent settings.
 */
@Injectable()
export class CalendarYearPickerConfig {
  public enabled = true;
}
